import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { usePatientAuth } from "../store/authPatientStore";

type Props = {
  children: ReactNode;
};

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <p className="text-gray-600">Chargement...</p>
  </div>
);

export default function RequireAuthPatient({ children }: Props) {
  const { isAuthenticated, isLoading } = usePatientAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen />;

  if (!isAuthenticated) {
    const redirectTo = `/patient/connexion?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
